var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.065 1.191a.936.936 0 00-1.292.281L16.26 16.171 6.75 1.472a.936.936 0 10-1.572 1.011l9.362 14.474H8.772a.936.936 0 000 1.872h6.553v2.809H8.772a.936.936 0 000 1.872h6.553v6.554a.936.936 0 101.872 0V23.51h6.554a.936.936 0 100-1.872h-6.554v-2.809h6.554a.936.936 0 100-1.872h-5.767l9.362-14.474a.936.936 0 00-.281-1.292z"
  })));
}

export default SvgMoney;